// extracted by mini-css-extract-plugin
export default {"container":"container--KMwy3","markerAnimationScale":"markerAnimationScale--ehaug"};